var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconAf = function SvgIconAf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.218 1.19A11.95 11.95 0 0 0 12 0c-1.87 0-3.64.428-5.217 1.19L5.739 12l1.044 10.81A11.95 11.95 0 0 0 12 24c1.87 0 3.64-.428 5.218-1.19L18.26 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.783 1.191A12 12 0 0 0 0 12.001a12 12 0 0 0 6.783 10.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496E2D",
    d: "M17.218 1.191V22.81A12 12 0 0 0 24 12a12 12 0 0 0-6.782-10.809"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.827a4.174 4.174 0 1 0 0 8.347 4.174 4.174 0 0 0 0-8.347m0 6.782a2.609 2.609 0 1 1 0-5.217 2.609 2.609 0 0 1 0 5.217"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.436c-.576 0-1.043.467-1.043 1.044v1.565h2.087V11.48c0-.577-.467-1.044-1.043-1.044"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconAf;